<!-- TODO : Need UI/UX intervention for responsive design-->
<div id="tvd-program-table" class="p-6 bg-white">
  <div class="program-table-title flex gap-4 mb-6 items-center">
    <img
      src="assets/total-value-delivery/metrics/tvd-employee-safety.svg"
      alt="TVD by Programs"
    />
    <span class="text-2xl">Programs</span>
  </div>

  <section
    id="program-table-filters"
    class="flex flex-col md:flex-row gap-4 mb-4"
  >
    <!-- Program Name Filter -->
    <div id="program-name-filter" class="relative w-64">
      <label class="neptune-floating-label-text-input"> Program </label>

      <input
        type="text"
        placeholder="Search by program name"
        class="box-border peer w-full rounded border-solid border-1 border-black !px-3 !py-3 outline-none transition-colors focus:border-blue placeholder:text-sm"
        [(ngModel)]="programSearchTerm"
        (input)="onProgramSearchInput()"
        (keydown.enter)="onProgramSearchEnter()"
      />
    </div>

    <!-- Region Filter -->
    <div id="program-region-filter" class="relative w-64">
      <multi-select-input
        [label]="'Region'"
        [floatingLabel]="true"
        [options]="availableRegions"
        [values]="selectedRegions"
        [displayFn]="getRegionDisplayName.bind(this)"
        [multiSelectionSummarySuffix]="'Regions Selected'"
        [ariaLabel]="'Region filter options'"
        (valuesChange)="onRegionFilterChange($event)"
        [noOptionsMessage]="'No regions available for selected filters'"
      ></multi-select-input>
    </div>

    <!-- Impact Category Filter -->
    <div id="program-impact-category-filter" class="relative w-64">
      <multi-select-input
        [label]="'Impact Category'"
        [floatingLabel]="true"
        [options]="availableImpactCategories"
        [values]="selectedImpactCategories"
        [multiSelectionSummarySuffix]="'Categories Selected'"
        [ariaLabel]="'Impact category filter options'"
        (valuesChange)="onImpactCategoryFilterChange($event)"
        [noOptionsMessage]="'No impact categories available for selected filters'"
      ></multi-select-input>
    </div>
  </section>

  <!-- Program Table -->
  <table class="w-full border-collapse text-sm">
    <thead
      id="program-table-header"
      class="border-neptune-border-subtle neptune-border-b-1 bg-neptune-muted"
    >
      <tr>
        <th class="program-col-header text-left px-2 py-2 text-blue">
          Program
        </th>
        <th class="impact-category-col-header text-left px-2 py-2 text-blue">
          Impact Categories
        </th>
        <th class="products-col-header text-left px-2 py-2 text-blue">
          Products
        </th>
        <th class="locations-col-header text-left px-2 py-2 text-blue">
          Locations
        </th>
        <th class="delivered-value-col-header text-right px-2 py-2 text-blue">
          Delivered Value
        </th>
        <!-- Actions column -->
        <th
          class="view-product-details-col-header px-2 py-2 text-right"
          aria-label="Actions"
        ></th>
      </tr>
    </thead>

    <tbody id="program-table-body">
      <tr
        *ngFor="let row of pagedRows; index as i"
        class="border-b-1 last:border-b-0 even:bg-neptune-muted odd:bg-white"
        [ngClass]="'program-row-' + (i + 1)"
        [attr.data-program-name]="row.program"
      >
        <td class="program-value px-2 py-2 truncate" [title]="row.program">
          {{ row.program }}
        </td>

        <td class="impact-category-value px-2 py-2">
          <span
            class="block truncate"
            [title]="row.impactCategories.join(', ')"
          >
            {{ row.impactCategories.join(", ") }}
          </span>
        </td>

        <td class="products-value px-2 py-2">{{ row.totalProducts }}</td>
        <td class="locations-value px-2 py-2">{{ row.totalLocations }}</td>

        <td class="program-delivered-value px-2 py-2 text-right">
          <span class="currency-symbol">{{
            currencyCode | currencySymbol
          }}</span>
          <span class="delivered-value">
            <!--TODO : This a good candidate for a pipe. Similar logic is being used in tvd-details-page.component.ts -->
            <ng-container
              *ngIf="
                row.totalValueDelivered.value > 0 &&
                  row.totalValueDelivered.value < 1;
                else actualValue
              "
            >
              &lt;1
            </ng-container>
            <ng-template #actualValue>
              {{
                displayInRoundedNumber
                  ? (getDisplayValue(row.totalValueDelivered.value)
                    | abbreviateNumber)
                  : (getDisplayValue(row.totalValueDelivered.value)
                    | number: "1.0-0")
              }}
            </ng-template>
          </span>
        </td>
        <td class="view-product-details px-2 py-2 text-right">
          <div
            class="relative inline-block"
            appClickOutside
            (appClickOutside)="closeRowActions()"
          >
            <button
              type="button"
              class="cursor-pointer select-none rounded px-2 py-1 text-lg leading-none bg-transparent hover:bg-light-blue"
              aria-label="Open actions"
              (click)="toggleRowActions(row.program, $event)"
            >
              <img
                src="../../../../../assets/shared-icons/neptune-ellipsis-icon.svg"
                alt="Ellipsis icon"
                class="w-6 h-6"
              />
            </button>
            <div
              *ngIf="isRowActionsOpen(row.program)"
              class="view-product-details-popup absolute right-0 z-10 mt-1 min-w-[140px] rounded border-1 border-neptune-border-subtle bg-white shadow"
              (click)="$event.stopPropagation()"
            >
              <a
                class="font-medium text-sm text-left text-blue no-underline cursor-pointer block px-3 py-2 hover:bg-light-blue"
                [routerLink]="'/total-value-delivery-program-details'"
                [queryParams]="{ program: row.program }"
              >
                View Product Details
              </a>
            </div>
          </div>
        </td>
      </tr>

      <!-- Empty/Loading State -->
      <ng-container *ngIf="isLoading; else noData">
        <tr>
          <td colspan="6" class="px-4 py-6 text-center">
            <loader
              size="medium"
              class="flex items-center justify-center"
            ></loader>
          </td>
        </tr>
      </ng-container>
      <ng-template #noData>
        <tr *ngIf="pagedRows.length === 0">
          <td
            colspan="6"
            class="no-data-message px-4 py-6 text-center text-gray-500"
          >
            No data available for the selected filters.
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>

  <div id="tvd-programs-table-paginator" class="program-table-paginator">
    <paginator
      [currentPage]="pageIndex + 1"
      [totalItems]="tableRows.length"
      [limit]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 50]"
      (pageChange)="onPageChange($event)"
    >
    </paginator>
  </div>
</div>
